import { expenseColNm } from "./expenseConstant"
import { jobOrderColNm } from "./jobOrderConstant"

export const subcontractApiNm = {
  getSubcontractWithPrice: "/subcontract/getSubcontractWithPrice",
  getSubcontract: "/subcontract/getSubcontract",
  insertSubcontract: "/subcontract/insertSubcontract",
  updateSubcontract: "/subcontract/updateSubcontract",
  deleteSubcontract: "/subcontract/deleteSubcontract",
  updateAndSendSubcontractEmail: "/subcontract/updateAndSendSubcontractEmail",
  sendEmail: "/subcontract/sendEmail",
  getSubcontractLinkJob: "/subcontract/getSubcontractLinkJob",
  insertSubcontractLinkJob: "/subcontract/insertSubcontractLinkJob",
  updateSubcontractLinkJob: "/subcontract/updateSubcontractLinkJob",
  unlinkSubcontractLinkJob: "/subcontract/unlinkSubcontractLinkJob"
}

export const subcontractJobApiNm = {
  getSubcontractJob: "/subcontract-job/getSubcontractJob",
  insertSubcontractJob: "/subcontract-job/insertSubcontractJob",
  updateSubcontractJob: "/subcontract-job/updateSubcontractJob",
  deleteSubcontractJob: "/subcontract-job/deleteSubcontractJob"
}

export const subcontractExpenseApiNm = {
  getSubcontractExpense: "/subcontract-expense/getSubcontractExpense",
  getSubcontractExpenseJobOrder: "/subcontract-expense/getSubcontractExpenseJobOrder",
  getSubcontractExpenseJobOrderV2: "/subcontract-expense/getSubcontractExpenseJobOrderV2",
  getSubcontractExpenseJob: "/subcontract-expense/getSubcontractExpenseJob",
  insertUpdateSubcontractExpenseBulk: "/subcontract-expense/insertUpdateSubcontractExpenseBulk",
  updateSubcontractExpense: "/subcontract-expense/updateSubcontractExpense",
  deleteSubcontractExpense: "/subcontract-expense/deleteSubcontractExpense",
  insertLinkSubcontractInvoice: "/subcontract-expense/insertLinkSubcontractInvoice",
  importSubcontractExpenses: "/subcontract-expense/importSubcontractExpenses",
  saveExpenseMapping: "/subcontract-expense/saveExpenseMapping",
  getExpenseMappings: "/subcontract-expense/getExpenseMappings",
  removeExpenseMapping: "/subcontract-expense/removeExpenseMapping",
}
export const subcontractInvoiceApiNm = {
  getSubcontractInvoice: "/subcontract-invoice/getSubcontractInvoice",
  getSubcontractInvoiceTable: "/subcontract-invoice/getSubcontractInvoiceTable",
  getSubcontractPaymentVoucherReport: "/subcontract-invoice/getSubcontractPaymentVoucherReport",
  generateXpssDocNum: "/subcontract-invoice/generateXpssDocNum",
  insertSubcontractInvoice: "/subcontract-invoice/insertSubcontractInvoice",
  insertSubcontractInvoiceWithExpense: "/subcontract-invoice/insertSubcontractInvoiceWithExpense",
  uploadFile: "/subcontract-invoice/uploadFile",
  updateFileName: "/subcontract-invoice/updateFileName",
  deleteFile: "/subcontract-invoice/deleteFile",
  updateSubcontractInvoiceRmk: "/subcontract-invoice/updateSubcontractInvoiceRmk",
  updateSubcontractInvoiceColumn: "/subcontract-invoice/updateSubcontractInvoiceColumn",
  deleteSubcontractInvoice: "/subcontract-invoice/deleteSubcontractInvoice"
}

export const subcontractColNm = {
  ScId: "รถร่วม",
  Name: "ชื่อรถร่วม",
  SName: "ชื่อเรียก",
  Addr: "ที่อยู่",
  Tel: "โทร",
  TaxId: "เลขประจำตัวผู้เสียภาษี",
  Abbr: "ตัวย่อ",
  CtDscp: "ข้อมูลติดต่อ",
  CtMailOpr: "อีเมลฝ่ายปฏิบัติการ",
  CtMailAcc: "อีเมลฝ่ายบัญชี",
  XpssSupCod: "รหัสผู้ขาย Express",
  Rmk: "หมายเหตุ",
  Email: "Login E-mail",
  Pass: "Password",
  LnkSiteAbbr: "ตัวย่อ Link Emily",
}

export const subcontractJobColNm =  {
  JobSName: "ชื่องาน",
  ScId: "รถร่วม",
  SubNm: "รถร่วม",
  ContNo: jobOrderColNm.ContNo,
  ContSize: jobOrderColNm.ContSize,
  ContTyp: jobOrderColNm.ContTyp,
  TlrTyp: jobOrderColNm.TlrTyp,
  ShpmTypId: jobOrderColNm.ShpmTypId,
  TlrTypId: jobOrderColNm.TlrTypId,
  UntPr: expenseColNm.UntPr,
  Prty: expenseColNm.Prty,
  Rmk: "หมายเหตุ",
  ModDte: "วันที่แก้ไข",
  ModAcc: "ผู้แก้ไข",
  POIId: "สถานที่"
}

export const subcontractJobOrderColNm = {
  JobOrdId: jobOrderColNm.JobOrdId,
  AptTm: jobOrderColNm.AptTm,
  TakePlc: jobOrderColNm.TakePlc,
  RtnPlc: jobOrderColNm.RtnPlc,
  Loc: jobOrderColNm.Loc,
  Rmk: "หมายเหตุใบงาน",
  ScSNm: "รถร่วม",
}

export const subcontractInvoiceColNm = {
  ScInvId: "เลขที่ใบแจ้งหนี้รถร่วม",
  ScInvNo: "เลขที่ใบแจ้งหนี้รถร่วม",
  ScInvDte: "วันที่ใบแจ้งหนี้",
  XpssDocNum: "เลขเอกสาร บัญชี",
  XpssDocDte: "วันที่เอกสาร บัญชี",
  DueDte: "วันที่ครบกำหนดชำระ",
  CrDay: "เครดิต (วัน)",
  Rmk: "หมายเหตุ",
  AptTm: jobOrderColNm.AptTm,
  JobOrdId: jobOrderColNm.JobOrdId,
  JobNo: jobOrderColNm.JobNo,
  Bkg: jobOrderColNm.Bkg,
  ContNo: jobOrderColNm.ContNo,
  Loc: jobOrderColNm.Loc,
  CusSNm: jobOrderColNm.CusSNm,
  ScSNm: "รถร่วม",
  NumJobOrd: "จำนวนใบงาน",
  OwnRcptAmnt: "ใบเสร็จบริษัท",
  CusRcptAmnt: "ใบเสร็จลูกค้า",
  Total: "รวม",
  PVNo: "ใบสำคัญจ่าย",
  Files: "Files"
}

export const subcontractExpenseColNm = {
  ExpId: "รายได้",
  ExpNm: "รายได้",
  JobOrdId: "เลขที่ใบงาน",
  VatPrct: "Vat(%)",
  VatPr: "Vat",
  WhtPrct: "หัก ณ ที่จ่าย(%)",
  WhtPr: "หัก ณ ที่จ่าย",
  UntPr: "ราคา",
  Qty: "จำนวน",
  Total: "รวม",
  PayAmnt: "ยอดจ่าย",
  IsOwnRcpt: "ประเภทใบเสร็จ",
  WhtPayrTyp: "รูปแบบการหัก",
  WhtTypId: "ประเภทหัก ณ ที่จ่าย",
  WhtTypNm: "ประเภทหัก ณ ที่จ่าย",
  SupId: "ผู้จำหน่าย",
  SupSNm: "ผู้จำหน่าย",
  DocDte: "วันที่เอกสาร",
  Rmk: "หมายเหตุ",
}

export const whtPayrTypOptions = [
  { value: null, label: "-" },
  { value: "A", label: "กระทำการแทน" },
  { value: "O", label: "บริษัททำการหัก" },
  { value: "C", label: "ลูกค้าทำการหัก" },
]